import { IconButton } from "@mui/material";
import useAPI from "../../../api/hooks/useAPI";
import useColors from "../../../api/hooks/useColors";
import SvgToIcon from "../../../icons/SvgToIcon";
import { icons } from "../../stack/environment/icons/iconExport";

const SettingsButton = ({ setDrawerOpen }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();
  return (
    <IconButton
      onClick={() => {
        trackEvent("User clicked on customize dashboard view");
        setDrawerOpen(true);
      }}
      sx={{
        background: colors.common_white,
        color: colors.action_active,
        height: "32px",
        width: "32px",
        border: "1px solid " + colors.enabled_stroke,
        borderRadius: "8px",
        textTransform: "none",
        whiteSpace: "nowrap",
        "&:hover": {
          background: colors.grey_8percent,
        },
      }}
    >
      <SvgToIcon
        IconLogo={icons.SettingsIcon}
        style={{
          width: "16.5px",
          height: "16.5px",
          color: colors.icon_action_active,
        }}
      />
    </IconButton>
  );
};

export default SettingsButton;
